var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.846 4.834l-3.2 2.327c-.036.026-.051.072-.038.114l1.224 3.763c.05.153-.006.32-.136.414-.13.095-.305.095-.436 0L6.06 9.127c-.036-.024-.082-.024-.118 0l-3.202 2.327c-.13.094-.305.094-.435 0-.13-.095-.185-.262-.136-.415l1.224-3.763c.013-.042-.002-.088-.038-.114l-3.2-2.327C.024 4.74-.03 4.573.018 4.42c.05-.153.193-.256.354-.255h3.956c.045 0 .084-.029.098-.071L5.648.33C5.698.178 5.84.075 6 .075c.16 0 .303.103.352.256l1.222 3.763c.014.042.053.071.098.071h3.956c.16-.001.304.102.354.255.05.153-.006.32-.136.414z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c297e822.svg";
export { ForwardRef as ReactComponent };